import { connect } from 'react-redux';
import { Dispatch, Action } from 'redux'
import Map from '../Components/Map';
import {
    addDetectorConfigs, addDetectorMaps, addLanePollData, addLinkGeometries,
    addLinkPollData, addNodes, addLinks, addLanes, addCameras, addDmses,
    setJwt, clearJwt, addLinkMaps, setUserData
} from 'Actions/index';
import {
    Link, DetectorConfig, Lane, LinkGeometry, LinkData, LanePollData, Node, DetectorMap, Dms, Camera, UserData
} from 'NSwag/ServerClient/Client.nswag';

import { IStore } from 'Components/Map/Store/index';
import { ILinkMaps } from 'Store/index';

/**
* Maps the state to their respective properties
* @param { object } state - list of properties that define the state
* @param { object } ownProps - the properties
*/
const mapStateToProps = (state: IStore, ownProps: any) => ({
    cameras: state.cameras,
    tssLinks: state.links,
    tssDetectors: state.detectors,
    tssDetectorMaps: state.detectorMaps,
    jwt: state.jwt,
    dmses: state.dmses
});

/**
* Maps actions to their respective props
* @param { action } dispatch - dispatch action 
* @param { object } ownProps - the properties
*/
const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: any) => ({
    addDetectorConfigs: (detectors: DetectorConfig[]) => dispatch(addDetectorConfigs(detectors)),
    addNodes: (nodes: Node[]) => dispatch(addNodes(nodes)),
    addLinkGeometries: (geometries: LinkGeometry[]) => dispatch(addLinkGeometries(geometries)),
    addLinkMaps: (maps: ILinkMaps) => dispatch(addLinkMaps(maps)),
    addLinks: (links: Link[]) => dispatch(addLinks(links)),
    addLanes: (lanes: Lane[]) => dispatch(addLanes(lanes)),
    addDetectorMaps: (detectorMaps: DetectorMap[]) => dispatch(addDetectorMaps(detectorMaps)),
    addLanePollData: (lanePollData: LanePollData[])=> dispatch(addLanePollData(lanePollData)),
    addLinkPollData: (linkPollData: LinkData[]) => dispatch(addLinkPollData(linkPollData)),
    clearJwt: () => dispatch(clearJwt()),
    addDmses: (dmses: Dms[]) => dispatch(addDmses(dmses)),
    addCameras: (cameras: Camera[]) => dispatch(addCameras(cameras)),
    addUserData: (userData: UserData) => dispatch(setUserData(userData))
});

/**
* Maps these constants defined constants to the given component
* @return { function } returns a lambda that gets called immediately with a component
*/
const MapContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Map);

export default MapContainer;